import { useSelector } from 'react-redux';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { apiCallback } from '@vantiva-sa/homesight_humaui/Services/Common';
import { useApiQuery } from './useApiQuery';

const useGetUserState = (props, options) => {
  const { useruuid, userStateList } = props;
  const trans = useSelector(translator);
  const userEventsApi = useSelector((state) => state.apis.userEventsApi);
  const userstates = userStateList?.userstates;
  const payload = { userStateList: userStateList };

  return useApiQuery(
    ['getUserState', useruuid, (userstates || []).join(',')],
    () =>
      new Promise((resolve, reject) => {
        userEventsApi.getUserState(
          useruuid,
          payload,
          apiCallback({
            translator: trans,
            successCallback: (data) => {
              resolve(data['data'] || []);
            },
            errorCallback: () => {
              reject([]);
            },
            failCallback: () => {
              reject([]);
            },
          })
        );
      }),
    {
      enabled: !!useruuid && Array.isArray(userstates) && userstates.length > 0,
      ...options,
    }
  );
};

export default useGetUserState;
